// apps/auth/src/store/baseQuery.js

import { createBaseQueries, IsProdMode } from '@gyandiksha/shared-ui';
const API_URL = (IsProdMode) ? import.meta.env.VITE_PROD_API_URL : import.meta.env.VITE_LOCAL_API_URL

// Location/sreg no longer goes through here — it's served by shared-ui's own
// locationApi, which owns its own baseQuery pointed at getExternalAppUrl('location')
// (same host for every portal, so no per-app externalApiBaseUrl wiring needed).
export const { baseQuery, defaultBaseQuery, customFetchBase } = createBaseQueries({
    apiUrl: API_URL,
});